<template>
  <ValidationProvider #default="{ errors }" :name="name" :rules="faildRules">
    <b-form-group
      :label-cols="labelCols"
      v-bind="$attrs"
      class="ek-form-group"
      :label-for="'label-for-select-' + id"
    >
      <v-select
        @update="$emit('change', $event)"
        @change="$emit('change', $event)"
        :id="'label-for-select-' + id"
        @input="setInnerVal"
        :value="innerVal"
        :options="options"
        :reduce="(item) => (valueLabel ? item[valueLabel] : item)"
        :label="textLabel"
        :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
        :clearable="clearable"
        :multiple="multiple"
        :placeholder="placeholder"
        :selectable="selectable"
        class="rounded"
        :class="[fieldClass, { 'border-danger': errors[0] }]"
        :disabled="disabled"
      >
        <template #list-header>
          <slot name="list-header"></slot>
        </template>
        <template #option="{ name }">
          <slot name="option" :label="name"></slot>
        </template>
        <template #selected-option="x">
          <slot name="selected-option" :data="x"></slot>
        </template>
        <template #list-footer>
          <slot name="list-footer"></slot>
        </template>
        <template v-slot:no-options="{ search, searching }">
          <slot name="no-options" :search="search" :searching="searching"></slot>
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider, localize } from "vee-validate";
import { BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import ar from "vee-validate/dist/locale/ar.json";
import { handleLangChange } from "@/libs/event-bus";
import {
  required,
  email,
  min,
  confirmed,
  regex,
  url,
  credit,
  password,
  between,
  alpha,
  integer,
  digits,
  alphaDash,
  alphaNum,
  length,
  no_spaces,
  positive,
} from "@validations";
export default {
  components: {
    vSelect,
    ValidationProvider,
    // bootstrap vue
    BFormGroup,
  },
  props: {
    options: Array,
    clearable: {
      type: Boolean,
      default: () => false,
    },
    labelCols: {
      type: Number,
      default: () => 12,
    },
    placeholder: {
      type: String,
      default: "اختر عنصر",
    },
    valueLabel: {
      type: String,
      default: () => "id",
    },
    textLabel: {
      type: String,
      default: "name",
    },
    multiple: Boolean,
    value: {
      type: null,
    },
    selectable: {
      type: Function,
      default: () => true,
    },
    name: {
      type: String,
      required: true,
    },
    vid: {
      type: String,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    fieldClass: String,
    disabled: {
        type: Boolean,
        default: () => false
    }
  },
  setup(props) {
    let faildRules = "";
    let fields = {};
    props.rules.forEach((rule) => {
      faildRules += rule.type + "|";
      fields[rule.type.split(":")[0]] = rule.message;
    });
    faildRules = faildRules.slice(0, faildRules.length - 1);
    localize("ar", {
      messages: ar.messages,
      fields: {
        [props.name]: fields,
      },
    });
    return { faildRules };
  },
  mounted() {
    if (this.value) {
      this.innerVal = this.value;
    }
    handleLangChange(() => {
      setTimeout(() => {
        this.reInit();
      }, 400);
    });
  },
  methods: {
    reInit() {
      let faildRules = "";
      let fields = {};
      this.rules.forEach((rule) => {
        faildRules += rule.type + "|";
        fields[rule.type.split(":")[0]] = rule.message;
      });
      faildRules = faildRules.slice(0, faildRules.length - 1);
      localize(this.$store.getters["app/lang"] ? "en" : "ar", {
        messages: ar.messages,
        fields: {
          [this.name]: fields,
        },
      });
      this.faildRules = faildRules;
    },
    setInnerVal(e) {
      this.innerVal = e;
      this.$emit("change", e);
    },
  },
  data: () => ({
    innerVal: null,
    id: Math.random() * 100000,

    // validation
    required,
    email,
    min,
    confirmed,
    regex,
    url,
    credit,
    password,
    between,
    alpha,
    integer,
    digits,
    alphaDash,
    alphaNum,
    length,
    no_spaces,
    positive,
  }),
  watch: {
    innerVal(v) {
      this.$emit("input", v);
    },
    value(v) {
      this.innerVal = v;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-select {
  border: solid 1px #d8d6de;
}
::v-deep .vs__dropdown-toggle {
  border: none;
  background: #ffff;
  input::placeholder {
    color: #b9bfd3;
  }
  .vs__open-indicator {
    fill: #ccc;
  }
}
.ek-form-group ::v-deep label {
  margin: 0%;
  font-size: inherit;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: calc(0.438rem + 1px);
  padding-bottom: calc(0.438rem + 1px);
}
</style>
